import * as dcmjs from 'dcmjs';

/**
 * A simple wrapper class to wrap a dcm-js dataset in a strongly typed
 * object. Use this to pass reference to a dcm-js dataset and avoid
 * using eslint disable lines elsewhere in the code.
 */
export class DcmJsDatasetWrapper {
    public dataset: unknown;

    constructor(dataset: unknown) {
        this.dataset = dataset;
    }

    private static readonly _empty = new DcmJsDatasetWrapper(null);
    static empty(): DcmJsDatasetWrapper {
        return this._empty;
    }

    /// Convert the dataset to a blob of DICOM data
    public asBlob(): Blob {
        if (!this.dataset) {
            throw new Error('No dataset to convert to blob');
        }
        return new Blob(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            [dcmjs.data.datasetToDict(this.dataset as any).write()],
            {
                type: 'application/dicom',
            }
        );
    }

    public setCharacterSet(characterSet: string): void {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this.dataset as any).SpecificCharacterSet = characterSet;
    }

    public get PatientID(): string {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (this.dataset as any)?.PatientID;
    }

    public get sopClassUID(): string {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (this.dataset as any)?.SOPClassUID;
    }
}
